<template>
    <v-text-field
        v-focus="focus ? focus : false"
        v-model="inputVal"
        v-bind="$attrs"
        v-on="$listeners"
        :required="$attrs.rules && $attrs.rules.length > 0"
        :prepend-icon="$attrs['prepend-icon'] ? $attrs['prepend-icon'] : ''"
        :prepend-inner-icon="$attrs['prepend-inner-icon'] ? $attrs['prepend-inner-icon'] : ''"
        :append-outer-icon="$attrs['append-outer-icon'] ? $attrs['append-outer-icon'] : ''"
        :append-icon="isVisible ? 'visibility' : 'visibility_off'"
        @click:append="isVisible = !isVisible"
        :type="isVisible ? 'text' : 'password'"
        browser-autocomplete="no"
    >
        <template v-for="(_, slot) of $slots" :slot=[slot]>
            <slot :name="slot"/>
        </template>
        <template v-for="(_, slot) of $scopedSlots" :slot=[slot] slot-scope="data">
            <slot :name="slot" v-bind="data" />
        </template>
    </v-text-field>
</template>

<script>

export default {
    props: ['focus', 'value'],
    data() {
        return {
            isVisible: false
        };
    },
    computed: {
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    }
};
</script>